// extracted by mini-css-extract-plugin
export default {"tab_selector":"tab_selector___nZWH3","tab_btn":"tab_btn___Ir2W8","active":"active___NVrfj","hidden":"hidden___UCUKe","max":"max___Ezjdm"};